module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-greyscale-042f9e33f1b1d02791c2706b5e009bb8.svg";